/* eslint-disable no-extend-native */
if (!Object.hasOwn) {
	Object.defineProperty(Object, 'hasOwn', {
		value(object, property) {
			if (object == null) {
				throw new TypeError('Cannot convert undefined or null to object');
			}
			return Object.prototype.hasOwnProperty.call(Object(object), property);
		},
		configurable: true,
		enumerable: false,
		writable: true
	});
}

if (!Promise.withResolvers) {
	Promise.withResolvers = function () {
		let resolve;
		let reject;
		const promise = new Promise((res, rej) => {
			resolve = res;
			reject = rej;
		});
		return { promise, resolve, reject };
	};
}

if (!URL.parse) {
	URL.parse = function (url) {
		try {
			return new URL(url);
		} catch {
			return null;
		}
	};
}

if (!Array.prototype.at) {
	Array.prototype.at = function (index) {
		index = Math.trunc(index) || 0;
		if (index < 0) {
			index += this.length;
		}
		if (index < 0 || index >= this.length) {
			return undefined;
		}
		return this[index];
	};
}

if (!AbortSignal.any) {
	AbortSignal.any = function (signals) {
		if (signals == null || typeof signals[Symbol.iterator] !== 'function') {
			throw new TypeError(
				"Failed to execute 'any' on 'AbortSignal': The provided value cannot be converted to a sequence."
			);
		}

		const controller = new AbortController();
		const listeners = new WeakMap();

		function cleanup() {
			for (const signal of signals) {
				const listener = listeners.get(signal);
				if (listener) {
					signal.removeEventListener('abort', listener);
				}
			}
		}

		function onAbort(signal) {
			controller.abort(signal.reason);
			cleanup();
		}

		for (const signal of signals) {
			if (!(signal instanceof AbortSignal)) {
				throw new TypeError(
					"Failed to execute 'any' on 'AbortSignal': Failed to convert value to 'AbortSignal'."
				);
			}

			if (signal.aborted) {
				controller.abort(signal.reason);
				return controller.signal;
			}

			const listener = () => onAbort(signal);
			listeners.set(signal, listener);
			signal.addEventListener('abort', listener);
		}

		return controller.signal;
	};
}

if (!Array.prototype.toSpliced) {
	Array.prototype.toSpliced = function (start, deleteCount, ...items) {
		const arr = this.slice();
		arr.splice(start, deleteCount, ...items);

		return arr;
	};
}
